
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateReservationDtoFormGroup() {
return new FormGroup({
    businessunitId: new FormControl<number | undefined>(undefined, [Validators.required]),
    reservationteamId: new FormControl<number | undefined>(undefined, [Validators.required]),
    reservationtypeIds: new FormControl<Array<number> | undefined>([], [Validators.required]),
    start: new FormControl<string | undefined>(undefined, [Validators.required]),
    end: new FormControl<string | undefined>(undefined, [Validators.required]),
    titleId: new FormControl<number | undefined>(undefined, [Validators.required]),
    company: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    firstName: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    lastName: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    street: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    zipcode: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(10)]),
    city: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    canton: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(10)]),
    objectStreet: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    objectZip: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(10)]),
    objectCity: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    objectCanton: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(10)]),
    notes: new FormControl<string | undefined>(''),
    email: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    phone: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    utm: new FormControl<string | undefined>(''),
    referralCode: new FormControl<string | undefined>('', [Validators.maxLength(10)]),
})
;
}
      